module.exports = __webpack_public_path__ + "media/images/cabinet_show_passengers-5fc0e1db1700c0f703c925dd38a93478.svg";